// Generated by CoffeeScript 2.7.0
var Admin__Settings__WechatPayController;

import GenerateMorePopover from 'trunks/controllers/admin/settings/nav.js';

import SettingsNavigator from 'trunks/vue/admin/compositions/settings_sidebar/settings_navigator.js';

import SettingsWechatPay from 'trunks/vue/admin/components/settings/settings_container/settings_wechat_pay.js';

export default Admin__Settings__WechatPayController = (function() {
  class Admin__Settings__WechatPayController extends Skylark.App.BaseController {
    show() {
      this._generateSettingsSidebarView('settings__basic');
      return Skylark.Libs.Ajax.get('/admin/settings/wechat_pay.json', {
        success: function(data) {
          return new SettingsWechatPay({
            el: DomMaster.find("#js-settings-wechat_pay").node,
            propsData: {
              activeTab: 'wechat_pay',
              wechatPayOptions: data
            }
          });
        }
      });
    }

  };

  Admin__Settings__WechatPayController.include(GenerateMorePopover);

  Admin__Settings__WechatPayController.include(SettingsNavigator);

  return Admin__Settings__WechatPayController;

}).call(this);
